import { useCallback, useEffect, useState } from "react";
import { useSnackBar } from "../../context/SnackBarContext";

export function useRequest(api, defaultLoading = false) {
  const [isMounted, setIsMounted] = useState(true);
  const openSnack = useSnackBar();
  const [loading, setLoading] = useState(defaultLoading);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [isFetched, setIsFetched] = useState(false);

  useEffect(() => {
    return () => {
      setIsMounted(false);
    };
  }, []);

  const apiCall = useCallback(
    (props = {}) => {
      const {
        data = {},
        onSuccess = () => {},
        onError = (error) => {
          openSnack(true, { message: error.message });
        },
      } = props;
      setLoading(true);
      setError(null);
      setIsFetched(false);
      api(data)
        .then((response) => {
          if (isMounted) setResult(response.data);
          if (isMounted) setIsFetched(true);
          onSuccess(response.data);
        })
        .catch((error) => {
          let formattedError = {
            status: 0,
            message: "خطایی رخ داده است",
            data: null,
          };

          formattedError.data = error.response.data;
          formattedError.status = error.response.status || 0;

          if (error.response.data?.title) {
            formattedError.message = error.response.data.title;
          } else if (error.response.data?.message) {
            formattedError.message = error.response.data.message;
          } else {
            formattedError.message =
              error.response.statusText || "خطایی رخ داده است";
          }
          if (isMounted) setError(formattedError);
          if (isMounted) setLoading(false);
          if (
            !error.response ||
            error.response?.status === 401 ||
            error.response?.status === 423
          ) {
            setIsFetched(true);
            return;
          } else {
            onError(formattedError);
          }
        })
        .finally(() => {
          if (isMounted) setLoading(false);
        });
    },
    [api, openSnack]
  );

  return { loading, error, result, isFetched, apiCall };
}
